#@import GliveBooking.Views.Time
#@export GliveBooking.Views.Times

class GliveBooking.Views.Times extends BookingV2.Views.Collection

  module: 'glive-booking'

  templateName: 'times'

  childView: GliveBooking.Views.Time

  constructor: ->
    BookingV2.Views.Collection.apply this, arguments
    @on 'select', @select, this

  select: (time) ->
    @options.selected = time
    setTimeout (=> @render()), 0
